<table class="ap-calendar-table" [attr.aria-label]="_monthLabel">
    <thead class="ap-calendar-table-header">
        <tr>
            @for (day of _weekdays; track day) {
                <th [attr.aria-label]="day.long">{{ day.narrow }}</th>
            }
        </tr>
        <tr>
            <th class="ap-calendar-table-header-divider" colspan="7" aria-hidden="true"></th>
        </tr>
    </thead>
    <tbody
        ap-calendar-body
        aria-readonly="true"
        tabindex="0"
        [label]="_monthLabel"
        [rows]="_weeks"
        [todayValue]="_todayDate"
        [selectedValue]="_selectedDate"
        [activeCell]="getDate(activeDate) - 1"
        (selectedValueChange)="_dateSelected($event)"
        (keydown)="_handleCalendarBodyKeydown($event)"
    ></tbody>
</table>
